import React from 'react';
import slideStyle from '../style';

function YesNo(props){
    let style = slideStyle();
    return(
        <div 
         className='row'
         style={
             style.rowContainer()
         }
        >
            <div 
             className='col-6'
             style={
                style.hemisphere()
             }
            >
                <button
                 style={
                     style.button({lean: 'center'})
                 }
                 onClick={() => {props.nextPressed('yes')}}
                >
                    <p
                     style={style.buttonText()}
                    >
                        Yes
                    </p>
                </button>
            </div>
            <div 
             className='col-6'
             style={
                style.hemisphere()
             }
            >
                <button
                 style={
                     style.button({lean: 'center'})
                 }
                 onClick={() => {props.nextPressed('no')}}
                >
                    <p
                     style={style.buttonText()}
                    >
                        No
                    </p>
                </button>
            </div>
        </div>
    );
}

export default YesNo;